//natives
import React from "react";
import { Card, CardContent, Typography, CircularProgress, Tooltip } from "@material-ui/core/";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import imgBellAlert from "../../../../../../../../../../assets/imgBellAlert.png";

//components
import Unico from "../childrens/unico/Unico";
import Grupo from "../childrens/grupos/Grupo";

//controllers
import Config from "../../../../../../../../../../controllers/config";

//css
import Modal_Mini_ListCss from "./Modal_Mini_List-css";
const useStyles = Modal_Mini_ListCss();

export default function Modal_Mini_List(props) {
    const classes = useStyles();

    var permitido = false;
    if (
        (!!props.permissions["manter-comunicados"] === true && props.props.message == "comunicado") ||
        (!!props.permissions["manter-contatos"] === true && props.props.message == "contato") ||
        (!!props.permissions["manter-contatos"] === true && props.props.message == "pendencias")
     ) {
        permitido = true;
    }

    const mensagemAlerta = `Você possui 
    ${props.props.message === "pendencias" ? "novas" : "novos"} ${props.props.title}!`;
    return (
        <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
                <Typography variant="h5" className={classes.titleCartoes}>
                    {props.props.title}
                </Typography>

                {props.state.loading ? (
                    <div align={"center"}>
                        <CircularProgress />
                    </div>
                ) : (
                    <div style={{ height: 268, overflow: "auto" }}>
                        {props.props.message == "contato" ? (
                            <Grupo {...props} />
                        ) : (
                            <Unico {...props} />
                        )}
                    </div>
                )}
                { props.state.novo && (
                    <div className={classes.pos}>
                        <Tooltip disableFocusListener title={mensagemAlerta} placement="left">
                            {props.props.message == "pendencias" ? (
                                <img
                                    src={imgBellAlert}
                                    style={{ width: "75%", marginLeft: "12%", marginTop: "5%" }}
                                />
                            ) : (
                                <i style={{ fontSize: "20px", margin: "2%", padding: "4px", color: "white" }}>
                                    <FontAwesomeIcon icon={faBell} />
                                </i>
                            )}
                        </Tooltip>
                    </div>
                )}
            </CardContent>
        </Card>
    );
}
